module.exports = __webpack_public_path__ + "static/fx_10.ad93541e.jpg";